import { createContext } from "react";

export const CRFContext = createContext(null);
